import { Button } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import contentImage from 'src/images/svgs/certifications/certificate-banner-placeholder.svg';
import { StyledBannerTextWrapper, StyledHeadingWrapper, StyledBannerImage } from './certification-app-banner.styles';
export const CertificationAppBanner = () => <>
    <StyledBannerTextWrapper data-sentry-element="StyledBannerTextWrapper" data-sentry-source-file="certification-app-banner.tsx">
      <StyledHeadingWrapper data-sentry-element="StyledHeadingWrapper" data-sentry-source-file="certification-app-banner.tsx">
        <span>NEW</span>
        <h1>The only blue team certification to get you hired</h1>
      </StyledHeadingWrapper>
      <p>
        Become job-ready with a practical defensive certification designed by industry-expert, <br />
        security professionals.
      </p>
      <Link to="/security-analyst-level-1" data-sentry-element="Link" data-sentry-source-file="certification-app-banner.tsx">
        <Button color="primary" variant="solid" onClick={() => {}} data-sentry-element="Button" data-sentry-source-file="certification-app-banner.tsx">
          Learn more
        </Button>
      </Link>
    </StyledBannerTextWrapper>
    <StyledBannerImage src={contentImage} alt="Certification" data-sentry-element="StyledBannerImage" data-sentry-source-file="certification-app-banner.tsx" />
  </>;